var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('u-dialog', {
    attrs: {
      "title": "신청내역상세",
      "width": "1200",
      "max-width": "90%"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (_ref) {
        var attrs = _ref.attrs,
          on = _ref.on;
        return [_vm._t("activator", null, null, {
          attrs,
          on
        })];
      }
    }], null, true),
    model: {
      value: _vm.shows,
      callback: function ($$v) {
        _vm.shows = $$v;
      },
      expression: "shows"
    }
  }, [_c('v-tabs-items', {
    attrs: {
      "touchless": ""
    },
    model: {
      value: _vm.tab,
      callback: function ($$v) {
        _vm.tab = $$v;
      },
      expression: "tab"
    }
  }, [_c('v-tab-item', {
    attrs: {
      "value": "view"
    }
  }, [_c('form-view', _vm._b({
    ref: "view",
    model: {
      value: _vm.form,
      callback: function ($$v) {
        _vm.form = $$v;
      },
      expression: "form"
    }
  }, 'form-view', _vm.props_form, false)), _vm.isEditable ? _c('div', {
    staticClass: "btn-wrap btn-wrap--lg"
  }, [_c('v-row', {
    staticClass: "row--xs",
    attrs: {
      "justify": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "6",
      "sm": "auto"
    }
  }, [_c('btn-secondary-2', {
    staticClass: "w-100 min-w-sm-160px",
    attrs: {
      "x-large": ""
    },
    on: {
      "click": function ($event) {
        _vm.tab = 'delt';
      }
    }
  }, [_vm._v("신청취소")])], 1), _c('v-col', {
    attrs: {
      "cols": "6",
      "sm": "auto"
    }
  }, [_c('btn-primary-2', {
    staticClass: "w-100 min-w-sm-160px",
    attrs: {
      "x-large": ""
    },
    on: {
      "click": function ($event) {
        _vm.tab = 'form';
      }
    }
  }, [_vm._v("신청수정")])], 1)], 1)], 1) : _vm._e()], 1), _c('v-tab-item', {
    attrs: {
      "value": "form"
    }
  }, [_c('form-input', _vm._b({
    ref: "form",
    on: {
      "prev": function ($event) {
        _vm.tab = 'view';
      }
    }
  }, 'form-input', _vm.props_form, false))], 1), _c('v-tab-item', {
    attrs: {
      "value": "delt"
    }
  }, [_c('form-remove', _vm._b({
    ref: "delt",
    on: {
      "prev": function ($event) {
        _vm.tab = 'view';
      }
    }
  }, 'form-remove', _vm.props_form, false))], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }